import React, { PropsWithChildren } from 'react';


const MainPage: React.FunctionComponent<PropsWithChildren> = ({ children }) => {
	return <main>
		<div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8">{children}</div>
	</main>;
};

export default MainPage;